import { useEffect, useState } from "react";
import UseTranslationHook from "../../hooks/UseTranslationHook";
import {
  IBlogeCategory,
  fetchBlogCategoryApiCall,
  getBlogCategoryFields,
  handleActiveInactiveBlogCategory,
  handleDeleteBlogCategory,
} from "./BlogCategoryController";
import UsePaginationHook from "../../hooks/UsePaginationHook";
import { PER_PAGE_ROWS } from "../../config/AppConfig";
import { IPagination } from "../../data/AppInterface";
import { editIcon, eyeIcon, restoreIcon } from "../../assets/icons/SvgIconList";
import AdvanceSearch from "../../components/page-layouts/AdvanceSearch";
import ICTable from "../../core-component/ICTable";
import { ORDER_BY } from "../../utils/AppConstants";
import BlogCategoryForm from "./BlogCategoryForm";
import ICSweetAlertModal from "../../core-component/ICSweetAlertModal";

const BlogCategoryView = () => {
  const { t } = UseTranslationHook();
  let timer: NodeJS.Timeout;
  const [isLoading, setIsLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [readOnlyForm, setReadOnlyForm] = useState(false);
  const [enterpriseSearch, setEnterpriseSearch] = useState("");
  const [blogCategoryList, setBlogCategoryList] = useState<IBlogeCategory[]>(
    []
  );
  const [blogCategoryToEdit, setBlogCategoryToEdit] =
    useState<IBlogeCategory>();
  const [deleteAll, setDeleteAll] = useState(false);
  const { pagination, setPagination } = UsePaginationHook({
    pagination: {
      perPageRows: Number(PER_PAGE_ROWS),
      currentPage: 1,
      sortBy: "category_title",
      orderBy: "ASC",
    },
  });
  useEffect(() => {
    fetchBlogCategory(pagination);
    return () => {
      if (timer) clearTimeout(timer);
    };
  }, [enterpriseSearch, deleteAll]);
  const fetchBlogCategory = (payloadPagination: IPagination) => {
    if (timer) {
      clearTimeout(timer);
    }
    timer = setTimeout(async () => {
      setIsLoading(true);
      await fetchBlogCategoryApiCall(
        setBlogCategoryList,
        setPagination,
        payloadPagination,
        {
          enterpriseSearch,
          deleteAll,
        }
      );
      setIsLoading(false);
    }, 500);
  };

  const handleFaqsStatus = async (values: IBlogeCategory) => {
    var isStatusChange = await handleActiveInactiveBlogCategory(
      values.id,
      values.is_active === "1" ? "0" : "1"
    );
    if (isStatusChange) {
      const updatedBlogCategoryList = blogCategoryList.map((blogCategory) => {
        if (blogCategory.id === values.id) {
          return {
            ...blogCategory,
            is_active: values.is_active === "1" ? "0" : "1",
          };
        }
        return blogCategory;
      });

      setBlogCategoryList(updatedBlogCategoryList);
    }
  };

  const handleCloseForm = (status: boolean) => {
    setShowForm(false);
    setReadOnlyForm(false);
    if (blogCategoryToEdit) {
      setBlogCategoryToEdit(undefined);
    } else {
      setEnterpriseSearch("");
    }
    if (status) {
      fetchBlogCategory(pagination);
    }
  };
  const handleDeleteCfm = async (id: number) => {
    const data = await handleDeleteBlogCategory(id, t);
    if (data) {
      fetchBlogCategory(pagination);
    }
  };
  const customActionView = (item: IBlogeCategory) => {
    return (
      <div>
        {item.deleted === "1" ? (
          <div className="flex item-center justify-center ml-2">
            <div
              className="mr-2 action-view"
              title={t("restore")}
              onClick={() => handleDeleteCfm(item.id)}
            >
              {restoreIcon}
            </div>
          </div>
        ) : (
          <div className="flex item-center justify-center ml-2">
            <div
              className="mr-2 action-view"
              title={t("view_tooltip_icon")}
              onClick={() => {
                setShowForm(true);
                setBlogCategoryToEdit(item);
                setReadOnlyForm(true);
              }}
            >
              {eyeIcon}
            </div>
            <div
              className="mr-2 action-view "
              title={t("edit_tooltip_icon")}
              onClick={() => {
                setShowForm(true);
                setBlogCategoryToEdit(item);
              }}
            >
              {editIcon}
            </div>
            <div className="action-view " title={t("delete_tooltip_icon")}>
              <ICSweetAlertModal onConfirm={handleDeleteCfm} itemId={item.id} />
            </div>
          </div>
        )}
      </div>
    );
  };
  const allBlogCategoryList = blogCategoryList.map((val) => ({
    ...val,
    IsDeleted: val.deleted === "1" ? true : false,
  }));
  return (
    <div className="w-full overflow-auto scrollbar-remove">
      <AdvanceSearch
        handleOnClickAdd={() => setShowForm(true)}
        handleSearchChange={(text) => {
          setEnterpriseSearch(text);
        }}
        searchText={enterpriseSearch}
        handleDeleteCheckBox={(ans) => {
          setDeleteAll(ans);
        }}
        filterCheckBox={deleteAll}
        refreshTable={() => fetchBlogCategory(pagination)}
      />
      <ICTable<IBlogeCategory>
        isLoading={isLoading}
        totalFlex="grid grid-cols-15"
        fields={getBlogCategoryFields(handleFaqsStatus, customActionView, t)}
        data={allBlogCategoryList}
        pagination={pagination}
        handleChangePerPageRows={(perPageRow) =>
          fetchBlogCategory({
            ...pagination,
            perPageRows: perPageRow,
            currentPage: 1,
          })
        }
        handleChangePage={(page) =>
          fetchBlogCategory({ ...pagination, currentPage: page })
        }
        handleSort={(field) =>
          fetchBlogCategory({
            ...pagination,
            sortBy: field.key,
            orderBy:
              pagination.orderBy === ORDER_BY.desc
                ? ORDER_BY.asc
                : ORDER_BY.desc,
          })
        }
      />
      {showForm && (
        <BlogCategoryForm
          handleClose={handleCloseForm}
          blogCategoryToEdit={blogCategoryToEdit}
          readOnly={readOnlyForm}
        />
      )}
    </div>
  );
};
export default BlogCategoryView;
